import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IHttpErrorPayload, HttpRequestPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from 'src/app/core/services/http-provider/http-provider.service';
import { IRequestChequeBookModel, IRequestChequeBookResponseModel } from '../models/request-cheque-book.model';
import { PreLoginService } from 'src/app/pre-login/pre-login.service';

@Injectable({
  providedIn: 'root'
})
export class RequestChequeBookService {

  constructor(private httpProvider : HttpProviderService,
    private _preLoginService: PreLoginService) { }

  requestChequeBook(payload: IRequestChequeBookModel): Observable<any> {
    const payloadData = payload;
    const httpRequest : HttpRequestPayload = {
      resource : "/chequebookrequest",
      method : "POST",
      body : payloadData
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      const requestChequeBookResponse : IRequestChequeBookResponseModel = {
        httpStatus : response.status,
        inventoryNo : response.body.chequebookrequest.inventoryNumber,
        refNo: response.body.chequebookrequest.refNo,
      }
      if (response.status == 201) {
        this._preLoginService.setUserTwoFactor({ email: response.body.chequebookrequest.twoFactor.email, mobile: response.body.chequebookrequest.twoFactor.mobile });
      }
      return requestChequeBookResponse
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }

  fetchChequeBookDetails(requestReference): Observable<IRequestChequeBookModel> {
    const httpRequest : HttpRequestPayload = {
      resource : `/chequebookrequest/${requestReference}`,
      method : "GET"
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      const requestChequeBookResponse : IRequestChequeBookModel = response.body.chequebookrequest
      return requestChequeBookResponse
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
}
